import _ from 'lodash'
import api from '../../api'
import * as types from '../../types'

export default {
  state: {
    fileTypeList: [],
    fileList: []
  },
  getters: {
    [types.GET_UPLOAD_FILE_TYPE_DATA]: state => state.fileTypeList,
    [types.GET_UPLOAD_FILE_DATA]: state => state.fileList
  },
  actions: {
    [types.SET_UPLOAD_FILE_DATA] ({dispatch, commit}, params) {
      return api.getFileUploadList({
        token: params.token,
        frontApplyId: params.id
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          const result = resData.data.result
          commit(types.SET_UPLOAD_FILE_TYPE_DATA_STATE, result)
          commit(types.SET_UPLOAD_FILE_DATA_STATE, result)
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '上传文件信息获取失败'
          })
        }
      })
    },
    [types.SAVE_UPLOADED_FILE] ({dispatch, commit, getters}, params) {
      const fileTypeList = getters[types.GET_UPLOAD_FILE_TYPE_DATA]
      const arr = fileTypeList.map((item, index) => {
        const fileType = {
          sysFileIds: params.files[index].files.map((file) => {
            const result = {
              fileId: file.fileId,
              fileName: file.fileName
            }
            return result
          }),
          fileId: item.fileId,
          customerFileIsMustUpload: item.customerFileIsMustUpload,
          customerFilefileName: item.fileName
        }
        return fileType
      })
      return api.saveUploadFile({
        token: params.token,
        files: arr
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          dispatch(types.SET_UPLOAD_FILE_DATA, {
            router: params.router,
            token: params.token,
            id: params.id
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '文件信息保存失败'
          })
        }
        return res
      })
    }
    // [types.DELETE_UPLOADED_FILE] ({dispatch, commit}, params) {
    //   api.deleteUploadedFile({
    //     token: params.token,
    //     id: params.id
    //   }).then((res) => {
    //     const resData = res.data
    //     if (Number(resData.code) === 0) {
    //       // dispatch(types.SET_SUCCESS_MESSAGE, {
    //       //   show: true,
    //       //   content: resData.result
    //       // })
    //     } else if (Number(resData.code) === 999) {
    //       dispatch(types.SET_FAIL_MESSAGE, {
    //         show: true,
    //         content: resData.result
    //       })
    //       commit(types.SET_USER, {})
    //       params.router.push('/login')
    //     } else {
    //       dispatch(types.SET_FAIL_MESSAGE, {
    //         show: true,
    //         content: resData.result
    //       })
    //     }
    //     return res
    //   })
    // }
  },
  mutations: {
    [types.SET_UPLOAD_FILE_TYPE_DATA_STATE] (state, data) {
      state.fileTypeList = data
    },
    [types.SET_UPLOAD_FILE_DATA_STATE] (state, data) {
      state.fileList = data.map((item) => {
        if (_.isNull(item.sysFileIds)) {
          return {
            fileTypeId: item.fileId,
            files: []
          }
        } else {
         // 给已经保存好的文件增加一个标记，因为按照当前需求，已经保存好的文件不允许删除
          const files = JSON.parse(item.sysFileIds)
          return {
            fileTypeId: item.fileId,
            files: files.attachs.map(file => Object.assign(file, {
              hasSaved: true
            }))
          }
        }
      })
    },
    [types.SAVE_CURRENT_UPLOAD_FILE] (state, data) {
      const typeIndex = _.findIndex(state.fileList, item => item.fileTypeId === data.typeId)
      state.fileList[typeIndex].files.push(data.file)
    },
    [types.DELETE_UPLOADED_FILE] (state, data) {
      const typeIndex = _.findIndex(state.fileList, item => item.fileTypeId === data.typeId)
      const fileIndex = _.findIndex(state.fileList[typeIndex].files, item => _.isEqual(item, data.file))
      state.fileList[typeIndex].files.splice(fileIndex, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common/fileUpload.js